let STYLESHEET: Sheet | undefined = undefined

class Sheet {
  #sheet: CSSStyleSheet
  #content: { id: string; count: number }[]

  constructor() {
    const style = document.createElement('style')
    style.setAttribute('data-dynamic-css', 'true')
    document.head.appendChild(style)
    this.#sheet = style.sheet!
    this.#content = []
  }

  add(rule: string, id: string): void {
    let ruleIndex = this.#content.findIndex((item) => item.id === id)

    if (ruleIndex === -1) {
      ruleIndex = this.#content.length
      this.#content[ruleIndex] = { id, count: 0 }
      this.#sheet.insertRule(rule, ruleIndex)
    }

    this.#content[ruleIndex].count += 1
  }

  remove(id: string): void {
    const ruleIndex = this.#content.findIndex((item) => item.id === id)

    if (ruleIndex === -1) {
      return
    }

    this.#content[ruleIndex].count -= 1

    if (this.#content[ruleIndex].count <= 0) {
      this.#content.splice(ruleIndex, 1)
      this.#sheet.deleteRule(ruleIndex)
    }
  }
}

export function injectCss(rule: string, id: string) {
  const sheet = getSheet()

  sheet.add(rule, id)

  return () => {
    sheet.remove(id)
  }
}

function getSheet(): Sheet {
  if (STYLESHEET === undefined) {
    STYLESHEET = new Sheet()
  }
  return STYLESHEET
}
